<button mat-stroked-button color="accent" (click)="_clickHandler($event);" [disabled]="!enabled">
    <mat-icon [@_userLikesState]="_userLikesResolved ? true : false" >favorite</mat-icon>
    {{_numLikesResolved}}
</button>
